import baseApi from "./baseApi"

export default  {
    /**
     * Fetch weather data for all plants
     * @return {Object} -- Plant Data
     */
    async getWeatherDataForAllPlants() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/weather");
        return result.data;
    }
}